import styled from 'styled-components'

export const FormControlWrapper = styled.div`
  position: relative;
  margin-bottom: 8px;
`
